import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    onUpdateFieldEntity,
    onUpdateFieldFilter,
    onSearchVendedorClick,
} from "../../../store/fuerzaventas/cargarmiespacio/actions";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import { ActionField, FieldSet } from "@sigeco/tools";
import Checkbox from "@material-ui/core/Checkbox";
import { KeyboardDatePicker } from "@material-ui/pickers";
import TextField from "@material-ui/core/TextField";
import makeStyles from "@material-ui/core/styles/makeStyles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Icon } from "@material-ui/core";
import Button from "@material-ui/core/Button";

import { getDistribuidorDefault } from "../../../helpers/commons";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flex: "1 1 auto",
        flexDirection: "column",
    },
    content: {
        padding: "0.5rem 0.75rem 0.75rem",
    },
    tableWrap: {
        flex: "1 1 auto",
    },
    checkbox: {
        color: "#9c9c9c",
        padding: 0,
    },
    filterClear: {
        display: "flex",
    },
    actionField: {
        flexDirection: "row",
        position: "relative",
    },
    btnClear: {
        position: "absolute",
        bottom: "1.5",
        right: 20,
        maxWidth: "15px",
        maxHeight: "23px",
        minWidth: "15px",
        minHeight: "23px",
    },
}));

const CargarMiEspacioImportar = () => {
    const classes = useStyles();
    const matches = useMediaQuery("(min-width:701px)");
    const store = useSelector((state) => state.cargarmiespacio.store);
    const filters = useSelector((state) => state.cargarmiespacio.filters);
    const entity = useSelector((state) => state.cargarmiespacio.entity);
    const limpiar = useSelector((state) => state.cargarmiespacio.clean);
    const dispatch = useDispatch();
    const label = "Fecha Limite";

    useEffect(() => {
        getDistribuidorDefault(onUpdateFieldFilter, dispatch);
    }, []);

    const [files, setFiles] = useState([]);
    const [previews, setPreviews] = useState([]);
    const [image, setImage] = useState([]);
    const [vendedor, setVendedor] = useState("");
    const [btn, setBtn] = useState(true);

    function onFieldChange(event) {
        dispatch(onUpdateFieldEntity(event.target.name, event.target.value));
    }

    useEffect(() => {
        if (filters.vendedor.length !== 0) {
            setVendedor("Filtro Seleccionado");
            setBtn(false);
        } else {
            setBtn(true);
        }
    }, [filters.vendedor]);

    useEffect(() => {
        if (limpiar.limpiador) {
            setFiles([]);
            setPreviews([]);
            setImage([]);
        }
    }, [limpiar.limpiador]);

    const handleImageChange = (e) => {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
            setImage((prevImage) => [...prevImage, reader.result]);
        };
        reader.readAsDataURL(file);

        const selectedFiles = e.target.files;
        const filePreviews = [];

        for (let i = 0; i < selectedFiles.length; i++) {
            const file = selectedFiles[i];
            filePreviews.push(file.name);
        }

        setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
        setPreviews((prevPreviews) => [...prevPreviews, ...filePreviews]);
    };

    const handleVendedor = () => {
        setVendedor("");
        filters.vendedor = "";
        setBtn(true);
    };

    store.subida = image;
    entity.name = previews;
/*
    if (limpiar.limpiador === true) {
        setPreviews([]);
        limpiar.limpiador = false;
    }
*/
    const onCheckBoxChange = (event) => {
        dispatch(onUpdateFieldFilter(event.target.name, event.target.checked));
    };
    // console.log("PASAAA", store.subida)

    //console.log("LOCAL",files)

    //console.log(filters.fechaLimite)

    return (
        <FieldSet className={classes.root} iconCls="fas fa-th-list" title="Importar Archivos">
            <div className={classes.content}>
                <Grid container spacing={2} direction="column">
                    <Grid item xs={12} sm={8} md={6}>
                        <FormControl fullWidth>
                            <TextField
                                fullWidth
                                id="outlined-tag"
                                label="Tag"
                                name="tag"
                                onChange={onFieldChange}
                                required
                                value={entity.tag}
                                variant={matches ? "outlined" : "standard"}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={8} md={6}>
                        <FormControl fullWidth>
                            <TextField
                                fullWidth
                                id="outlined-comentario"
                                label="Comentario"
                                name="comentario"
                                onChange={onFieldChange}
                                required
                                multiline
                                minRows={4}
                                value={entity.comentario}
                                variant={matches ? "outlined" : "standard"}
                                inputProps={{
                                    maxLength: 650,
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={8} md={6}>
                        <Grid container direction="row" spacing={2}>
                            <Grid item>
                                <label style={{ fontSize: "11px", display: "flex", alignItems: "center" }}>
                                    <Checkbox
                                        name="fechaLimite"
                                        className={classes.checkbox}
                                        checked={filters.fechaLimite}
                                        color="primary"
                                        disableRipple
                                        onChange={onCheckBoxChange}
                                    />
                                    {label}
                                </label>
                            </Grid>
                            <Grid item>
                                <label style={{ fontSize: "11px", display: "flex", alignItems: "center" }}>
                                    <Checkbox
                                        name="compartir"
                                        className={classes.checkbox}
                                        checked={filters.compartir}
                                        color="primary"
                                        disableRipple
                                        onChange={onCheckBoxChange}
                                    />
                                    Descargar
                                </label>
                            </Grid>
                            <Grid item>
                                <label style={{ fontSize: "11px", display: "flex", alignItems: "center" }}>
                                    <Checkbox
                                        name="notificar"
                                        className={classes.checkbox}
                                        checked={filters.notificar}
                                        color="primary"
                                        disableRipple
                                        onChange={onCheckBoxChange}
                                    />
                                    Notificar
                                </label>
                            </Grid>
                        </Grid>
                    </Grid>
                    {filters.fechaLimite === true && (
                        <Grid item xs={12} sm={8} md={6}>
                            <KeyboardDatePicker
                                autoOk
                                disableToolbar
                                format="dd/MM/yyyy"
                                label="Hasta"
                                value={filters.hasta}
                                inputvariant={matches ? "outlined" : "standard"}
                                variant={matches ? "inline" : "dialog"}
                                onChange={(date) => dispatch(onUpdateFieldFilter("hasta", date))}
                                fullWidth
                            />
                        </Grid>
                    )}
                    {filters.notificar === true && (
                        <Grid item xs={12} sm={8} md={6}>
                            <FormControl className={classes.filterClear}>
                                <ActionField
                                    className={classes.actionField}
                                    autoComplete="off"
                                    fullWidth
                                    label="Vendedor"
                                    name="vendedor"
                                    value={vendedor}
                                    variant={matches ? "outlined" : "standard"}
                                    onHandleAction={() => dispatch(onSearchVendedorClick())}
                                />
                                <Button
                                    className={classes.btnClear}
                                    size="small"
                                    startIcon={<Icon className="fa fa-window-close" />}
                                    disabled={btn}
                                    onClick={handleVendedor}
                                />
                            </FormControl>
                        </Grid>
                    )}
                    <Grid item xs={12} sm={8} md={6}>
                        <FormControl>
                            <label
                                style={{
                                    marginLeft: "20px",
                                    background: "#e62e2d",
                                    color: "white",
                                    borderRadius: "5px",
                                    width: "140px",
                                    height: "30px",
                                    display: false,
                                    cursor: "pointer",
                                }}
                                disable="true"
                            >
                                {" "}
                                <i
                                    className={"fa fa-upload"}
                                    style={{
                                        marginTop: "8px",
                                        width: "20px",
                                        height: "20px",
                                        marginLeft: "15px",
                                        color: "white",
                                        marginRight: "5px",
                                    }}
                                />
                                Seleccionar
                                <input
                                    type="file"
                                    style={{ opacity: 0 }}
                                    accept="application/pdf, .png, .mp4"
                                    multiple
                                    onChange={handleImageChange}
                                />
                            </label>
                        </FormControl>
                    </Grid>
                    {previews.length > 0 && (
                        <Grid item xs={12} sm={8} md={6}>
                            <div
                                style={{
                                    overflowX: "auto",
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <table
                                    style={{
                                        marginTop: 15,
                                        margin: "0 auto",
                                        width: "100%",
                                    }}
                                >
                                    <thead>
                                        <tr>
                                            <th>LISTA DE ARCHIVOS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {previews.map((preview, index) => (
                                            <tr key={index}>
                                                <td>{preview}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </Grid>
                    )}
                </Grid>
            </div>
        </FieldSet>
    );
};

export default CargarMiEspacioImportar;
